import React from "react";
import CareWatchPreviewCard, { CareWatchPreviewRow } from "./CareWatchPreviewCard";
import { CARE_WATCH_STATUSES } from "../utils/constants";
import { adaptLiveParticipant, formatPersonName, formatShortDate } from "../utils/signalAdapter";

const shortShiftType = (value) => {
  if (!value) return "";
  return String(value).split(" ")[0];
};

const personName = (person) => {
  const adapted = adaptLiveParticipant(person);
  return formatPersonName(
    `${adapted.firstName || ""} ${adapted.lastName || ""}`.trim()
  );
};

const isGroupShift = (item, people = []) =>
  people.length > 1 || /group/i.test(String(item?.shiftType || ""));

const formatShiftSummary = (item, groupShift) => {
  const date = formatShortDate(item.shiftDate);
  const type = groupShift ? item.shiftType : shortShiftType(item.shiftType);
  return [date, type].filter(Boolean).join(" · ");
};

const previewHint = (item) => {
  if (
    item?.status === CARE_WATCH_STATUSES.PROMOTED ||
    item?.reportStatus === "reported"
  ) {
    return "Incident created";
  }
  if (item?.status === CARE_WATCH_STATUSES.ACKNOWLEDGED) {
    return "Acknowledged · no incident filed";
  }
  if (item?.promoteStarted) {
    return "Form opened · not submitted";
  }
  return "Draft only · not submitted";
};

const CareWatchIncidentPreview = ({
  item,
  people,
  title,
  highlighted = false,
}) => {
  const groupShift = isGroupShift(item, people);
  const participantLabel = groupShift
    ? `Participants (${people.length})`
    : "Participant";

  return (
    <CareWatchPreviewCard
      title="Incident form preview"
      hint={previewHint(item)}
      highlighted={highlighted}
    >
      {groupShift ? (
        <CareWatchPreviewRow label={participantLabel}>
          <ul className="care-watch-preview-card__people">
            {people.map((person, index) => {
              const adapted = adaptLiveParticipant(person);
              return (
                <li
                  key={adapted.uuid || adapted.initials || index}
                  className="care-watch-preview-card__person"
                >
                  <span className="care-watch-preview-card__person-av">
                    {adapted.initials}
                  </span>
                  <span>{personName(adapted)}</span>
                </li>
              );
            })}
          </ul>
        </CareWatchPreviewRow>
      ) : (
        <CareWatchPreviewRow label={participantLabel}>{title}</CareWatchPreviewRow>
      )}
      {/* The API sends `worker` as a display name, not an object -- reading
          .name off it left the row silently blank. */}
      <CareWatchPreviewRow label="Worker">
        {typeof item.worker === "string" ? item.worker : item.worker?.name}
      </CareWatchPreviewRow>
      <CareWatchPreviewRow label="Shift">
        <span className="care-watch-preview-card__shift">
          {formatShiftSummary(item, groupShift)}
          {groupShift ? (
            <span className="care-watch-preview-card__badge">Group shift</span>
          ) : null}
        </span>
      </CareWatchPreviewRow>
      <CareWatchPreviewRow label="Category">{item.categoryLabel}</CareWatchPreviewRow>
    </CareWatchPreviewCard>
  );
};

export default CareWatchIncidentPreview;
